/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DoseTimingResponse } from './DoseTimingResponse';
import {
    DoseTimingResponseFromJSON,
    DoseTimingResponseFromJSONTyped,
    DoseTimingResponseToJSON,
    DoseTimingResponseToJSONTyped,
} from './DoseTimingResponse';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';

/**
 * 
 * @export
 * @interface ConceptGroupResponseCurrentEntryStatus
 */
export interface ConceptGroupResponseCurrentEntryStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ConceptGroupResponseCurrentEntryStatus
     */
    isSapActive?: boolean;
    /**
     * 
     * @type {PatientCommonExpression}
     * @memberof ConceptGroupResponseCurrentEntryStatus
     */
    closestExpression?: PatientCommonExpression;
    /**
     * 
     * @type {DoseTimingResponse}
     * @memberof ConceptGroupResponseCurrentEntryStatus
     */
    priorDoseTiming?: DoseTimingResponse;
}

/**
 * Check if a given object implements the ConceptGroupResponseCurrentEntryStatus interface.
 */
export function instanceOfConceptGroupResponseCurrentEntryStatus(value: object): value is ConceptGroupResponseCurrentEntryStatus {
    return true;
}

export function ConceptGroupResponseCurrentEntryStatusFromJSON(json: any): ConceptGroupResponseCurrentEntryStatus {
    return ConceptGroupResponseCurrentEntryStatusFromJSONTyped(json, false);
}

export function ConceptGroupResponseCurrentEntryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConceptGroupResponseCurrentEntryStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'isSapActive': json['isSapActive'] == null ? undefined : json['isSapActive'],
        'closestExpression': json['closestExpression'] == null ? undefined : PatientCommonExpressionFromJSON(json['closestExpression']),
        'priorDoseTiming': json['priorDoseTiming'] == null ? undefined : DoseTimingResponseFromJSON(json['priorDoseTiming']),
    };
}

export function ConceptGroupResponseCurrentEntryStatusToJSON(json: any): ConceptGroupResponseCurrentEntryStatus {
    return ConceptGroupResponseCurrentEntryStatusToJSONTyped(json, false);
}

export function ConceptGroupResponseCurrentEntryStatusToJSONTyped(value?: ConceptGroupResponseCurrentEntryStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSapActive': value['isSapActive'],
        'closestExpression': PatientCommonExpressionToJSON(value['closestExpression']),
        'priorDoseTiming': DoseTimingResponseToJSON(value['priorDoseTiming']),
    };
}

